module.exports = __webpack_public_path__ + "img/avatar_sloth.a1c612ce.svg";